import { render, staticRenderFns } from "./CreateCustomerCrmSnapshotPopUp.vue?vue&type=template&id=132994f8&scoped=true&"
import script from "./CreateCustomerCrmSnapshotPopUp.vue?vue&type=script&lang=js&"
export * from "./CreateCustomerCrmSnapshotPopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomerCrmSnapshotPopUp.vue?vue&type=style&index=0&id=132994f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132994f8",
  null
  
)

export default component.exports